<template>
  <div>
    <DatePicker
      value=""
      :inline="true"
      @selected="dateSelected"
      :disabled-dates="{ customPredictor: predictDisabledDates }"
      :highlighted="{ customPredictor: predictHighlightedDates }"
    />
  </div>
</template>

<script>
import DatePicker from '@sum.cumo/vue-datepicker'
// import '@sum.cumo/vue-datepicker/dist/Datepicker.css'
import { timeHelpers } from "../../helpers/timeHelpers";
import '@sum.cumo/vue-datepicker/dist/Datepicker.css'


const DateType = { required: true, type: String }

export default {
  components: { DatePicker },
  props: {
    value: {
      type: Array,
      required: true
    },
    startAt: DateType,
    endAt: DateType
  },
  computed: {
    days() {
      return this.value.map(d => timeHelpers.fromDateFormat(d.day))
    },
    _startAt() {
      return timeHelpers.fromDateFormat(this.startAt)
    },
    _endAt() {
      return timeHelpers.fromDateFormat(this.endAt)
    }
  },
  data() {
    return {
      datePickerInput: ''
    }
  },
  name: "LabAdminDateExclusionPicker",
  methods: {
    predictDisabledDates(date) {
      return !(this._startAt <= date && this._endAt >= date);
    },
    dateSelected(date) {
      let knownDate = this.$moment(date, this.$moment.defaultFormat).format("YYYY-MM-DD");

      if (this.predictHighlightedDates(date)) {
        this.$emit('input', [...this.value, { day: knownDate}]);
      } else {
        this.$emit('input', [...this.value].filter(d => d.day !== knownDate));
      }
    },
    predictHighlightedDates(date) {
      if (this.predictDisabledDates(date)) {
        return false;
      }

      return ! this.days.some(d => timeHelpers.onSameDay(date, d))
    }
  }
}
</script>

<style>
  .vdp-datepicker__calendar.inline {
    @apply my-4;
    border: none !important;
    position: static;
    display: block;
  }
  .picker-view {
    @apply bg-white rounded;
  }

  .vdp-datepicker__calendar .cell.selected.highlighted, .vdp-datepicker__calendar .cell.selected:hover {
    background: inherit;
  }
  .vdp-datepicker__calendar .cell.selected.highlighted, .vdp-datepicker__calendar .cell.selected {
    background: inherit;
  }
  .highlighted {
    background: #cae5ed !important;
  }
</style>
